import React, { Component } from 'react';
import { TextInput } from '../shared/TextInput'
import { actions, selectors } from '../sagas/inviteUser';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form'

class InviteUser extends Component {

  handleCustomSubmit = () => {
    this.props.inviteUser()
    this.props.reset()
  }

  render() {
    const { handleSubmit } = this.props
    return (
        <div>
          <form onSubmit={handleSubmit(this.handleCustomSubmit)}>
            <TextInput
              inputName={'new_user_email'}
              label={'Invite user via email'}
              placeholderText='Email Address'
            />
            <button onClick={ this.handleCustomSubmit } style={{ marginTop: 7 }} className='alt-button setting-form' type="button">
              Send invite
            </button>
          </form>
        </div>
    )
  }
}

const mapStateToProps = (store) => ({
  initialValues: { new_user_email: selectors.email(store) }
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  {
    enableReinitialize: true,
    form: 'invite_user_form'
  })(InviteUser)));



// WEBPACK FOOTER //
// ./src/Settings/InviteUser.jsx